define( [
	"./class2type"
], function( class2type ) {
	return class2type.toString;
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/toString.js
 ** module id = 822
 ** module chunks = 2
 **/